export default "__VITE_ASSET__25acf45f__"